/**
 * Sanitizes a string value for API submission by converting empty strings to undefined.
 * This ensures empty form fields are omitted from API payloads rather than sent as empty strings.
 *
 * @param value - The string value to sanitize
 * @returns undefined if the string is empty or only whitespace, otherwise the trimmed string
 */
export function sanitizeStringForApi(value: string | undefined): string | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
}
